export default "__VITE_ASSET__DtQmWSqH__"